import {DialogActions, Typography} from '@mui/material';
import Button from 'components/Button';
import Dialog from 'components/Dialog';
import Panel from 'components/Panel';
import {layoutSelectors} from 'features/layout/redux';
import React, {memo} from 'react';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';

export type StatusDialogData = {
   title: string;
   open?: boolean;
};

type Props = {
   data: StatusDialogData;
   onClose: () => void;
};
const StatusDialog = memo(({onClose, data: {title, open = true}}: Props) => {
   const {t} = useTranslation();
   const {closeButtonLabel = t('Close'), textLines} = useSelector(
      layoutSelectors.activeDialogStatus
   );

   return (
      <Dialog open={open} maxWidth="lg" header={title} close={onClose}>
         <Panel>
            {textLines.map((line, i) => (
               <Typography key={i} component="pre">
                  {line}
               </Typography>
            ))}
         </Panel>

         <DialogActions>
            <Button type="button" onClick={() => onClose()}>
               {closeButtonLabel}
            </Button>
         </DialogActions>
      </Dialog>
   );
});

export default StatusDialog;
